import fcDirective from '../_util/fcDirective';
// import PerfectScrollbar from 'vue2-perfect-scrollbar'
// import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

const base = {};
const install = function(Vue) {
  base.Vue = Vue;
  Vue.use(fcDirective); // 注册指令，参考 https://v2.cn.vuejs.org/v2/api/#Vue-directive
  //todo 后面放使用到的组件里
  // Vue.use(PerfectScrollbar)
};
base.install = install;

export default base;
